import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BASEAPIURL } from '../../config';
import './FooterInstitute.css';
import { useTranslation } from 'react-i18next';

const today = new Date();
function Footer() {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false)

    function handleClick() {
        setIsVisible(!isVisible)
    }

    const [CatiData, setCatiData] = useState([]);

    const FetchCatiData = async () => {
        try {
            const res = await fetch(`${BASEAPIURL}/course/getAll`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    SortStatus: 1,
                    parent: 0,
                    featured: 0,
                    recordsPerPage: 30,
                    sortby: 'a2z',
                }),
            });
            const resJson = await res.json();
            if (res.status === 200) {
                if (Object.keys(resJson.data).length > 0) {
                    setCatiData(resJson.data);
                }
            } else {
                console.log(resJson.message);
            }
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        FetchCatiData();
    }, []);

    return (
        <>
            <section className="appie-footer-area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3">
                            <div className="footer-about-widget">
                                <div className="logo text-center">
                                    <Link className="d-block text-left" to="/">
                                        <img
                                            src="/AacumenGlowLogoSquare.png"
                                            alt="Acumen Glow"
                                            style={{
                                                maxWidth: '100px'
                                            }} />
                                    </Link>
                                </div>
                                <p className='text-white mt-2 text-left'>
                                    <small>
                                        {t('footer.description')}
                                    </small>
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-3 footer-navigation">
                            <ul>
                                <li>
                                    <Link to="/instructor">{t('beOurInstructor')}</Link>
                                </li>
                                <li>
                                    <Link to="/request-as-team">{t('learnAsTeam')}</Link>
                                </li>
                                <li>
                                    <Link to="/courses">{t('courses')}</Link>
                                </li>
                                <li>
                                    <Link to="/courses/eproducts">{t('eProducts')}</Link>
                                </li>
                                <li>
                                    <Link to="/blog">{t('blog')}</Link>
                                </li>
                            </ul>
                        </div>
                        <div className="col-lg-3 footer-navigation">
                            <ul>
                                <li>
                                    <Link to="/about-us">{t('aboutUs.title')}</Link>
                                </li>
                                <li>
                                    <Link to="/faq">{t('faqs')}</Link>
                                </li>
                                <li>
                                    <Link to="/contact-us">{t('help')}</Link>
                                </li>
                                <li>
                                    <Link to="/contact-us">{t('contactUs.title')}</Link>
                                </li>
                                <li>
                                    <Link to="/careers">{t('career.title')}</Link>
                                </li>
                                <li>
                                    {/* <Link to="/">Press</Link> */}
                                </li>
                            </ul>
                        </div>
                        <div className="col-lg-3 footer-navigation">
                            
                            <div className="footer-about-widget">
                                <h4 className="title text-white">{t('socialMedia')}</h4>
                                <div className="social">
                                    <ul>
                                        <li>
                                            <a
                                                className="fac"
                                                href="https://www.facebook.com/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <i className="fab fa-facebook-f" />
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                className="lin"
                                                href="https://www.linkedin.com/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <i className="fab fa-linkedin-in" />
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                className="inst"
                                                href="https://www.instagram.com/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <i className="fab fa-instagram" />
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                className="twit"
                                                href="https://x.com/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <i className="fab fa-twitter" />
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                className="you"
                                                href="https://www.youtube.com/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <i className="fab fa-youtube" />
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <h4 className="title text-white mt-30">{t('downloadMobileApp')}</h4>
                                <div className="apps-download-btn">
                                    <ul>
                                        <li>
                                            <a href="https://apps.apple.com/" target="_BLANK" rel="noopener noreferrer">
                                                <img src='/assets/img/apple-icon.png' alt="" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://play.google.com/" target="_BLANK" rel="noopener noreferrer">
                                                <img src='/assets/img/google-play-icon.png' alt="" />
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <button onClick={handleClick}>
                    <i className={`fas fa-caret-${!isVisible ? 'down' : 'up'}`} />
                </button>
            </section>

            {isVisible &&
                <section className="appie-footer-area bgTwo">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4 footer-navigation">
                                <h4 className="title">Trending Courses</h4>
                                {/* {console.log("CatiData")}
                                {console.log(CatiData)}
                                {console.log("CatiData")} */}
                                <ul>
                                    {CatiData
                                        .filter((s) => s.section === 'courses') // ✅ show only items where section is "course"
                                        .slice() // optional: to avoid mutating original array
                                        .sort((a, b) => a.title.localeCompare(b.title))
                                        .map((s) => (
                                        <li key={s._id}>
                                            <Link to={`/course/${s.slug}`}>{s.title}</Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="col-lg-4 footer-navigation">
                                <h4 className="title">Trending E-products</h4>
                                <ul>
                                    {CatiData
                                        .filter((s) => s.section === 'eproducts') // ✅ show only items where section is "e_products"
                                        .slice() // optional: avoid mutating original
                                        .sort((a, b) => b.view - a.view) // ascending order
                                        .map((s) => (
                                            <li key={s._id}>
                                                <Link to={`/course/${s.slug}`}>{s.title}</Link>
                                            </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="col-lg-4 footer-navigation">
                                <h4 className="title">Browse Popular</h4>
                                <ul>
                                    {CatiData
                                        .slice() // optional: avoid mutating original
                                        .sort((a, b) => b.orderNo - a.orderNo) // ascending order
                                        .map((s) => (
                                            <li key={s._id}>
                                                <Link to={`/course/${s.slug}`}>{s.title}</Link>
                                            </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
            }

            <section className="appie-footer-area copyright">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="footer-copyright">
                                <div className="copyright-text">
                                    <p>&copy; {today.getFullYear()} Acumen Glow</p>
                                    <Link to="/terms-and-conditions">{t('terms')}</Link>
                                    <Link to="/privacy-policy">{t('privacyPolicy')}</Link>
                                    <Link to="/refunds-and-cancellations">{t('refundPolicy')}</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Footer;
